import React from "react";
import Skills from "./Skills.js";
import Tilt from "react-parallax-tilt";
import Lottie from "lottie-react";
import about from "../LottieFiles/about.json";

const About = () => {
  return (
    <>
      <div className="AboutPage">
        <div className="AboutText">
          <h1 className="AboutTextHeading">
            About <b>me!</b>
          </h1>
          <p>
            I'm <b>Gopi Mishra</b>, a <b>full stack developer</b> with a{" "}
            <b>BCA degree</b>, passionate about building dynamic web
            applications.
            <br />I enjoy tackling both front-end and back-end challenges,
            constantly seeking to enhance my skills.
            <br />
            I'm particularly interested in{" "}
            <b>
              cybersecurity, software development, app development, Web3, and
              AI.
            </b>
            <br />
            I love exploring new technologies and frameworks, always looking for
            opportunities to innovate and create impactful solutions.
            <br />
            My diverse interests drive me to stay updated with industry trends
            and continuously learn, making me adaptable and versatile in the
            tech landscape.
          </p>
        </div>

        <div>
          <Tilt>
            <Lottie
              className="illustration"
              animationData={about}
              loop={true}
            />
          </Tilt>
        </div>
      </div>

      <h1 className="SkillsHeading">Skills</h1>
      <div className="skills">
        <Skills skill="React" />
        <Skills skill="Express" />
        <Skills skill="MongoDb" />
        <Skills skill="Node" />
        <Skills skill="HTML5" />
        <Skills skill="CSS3" />
        <Skills skill="Javascript" />
        <Skills skill="Bootstrap" />
        <Skills skill="TailwindCss" />
        <Skills skill="C++" />
        <Skills skill="C" />
        <Skills skill="Java" />
        <Skills skill="Python" />
        <Skills skill="Git" />
        <Skills skill="Github" />
        <Skills skill="Vercel" />
        <Skills skill="Netlify" />
      </div>
    </>
  );
};

export default About;
